import { render, staticRenderFns } from "./LastViewedImageCarousel.vue?vue&type=template&id=1d6133c9&"
import script from "./LastViewedImageCarousel.vue?vue&type=script&lang=js&"
export * from "./LastViewedImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d6133c9')) {
      api.createRecord('1d6133c9', component.options)
    } else {
      api.reload('1d6133c9', component.options)
    }
    module.hot.accept("./LastViewedImageCarousel.vue?vue&type=template&id=1d6133c9&", function () {
      api.rerender('1d6133c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8QK7xqFByOTng/JS/comp/LastViewedImageCarousel.vue"
export default component.exports